import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';

export default function ColContent({
    global,
    title,
    text,
    items
}) {
    return (
        <section className={`${styles.root} text-center my-3 py-5`}>
            <Container>
                <header className="mb-4">
                    {title}
                    {text}
                </header>
                {items && items.length > 0 && (
                    <Row>
                        {(items || []).map((item, index) => (
                            <Col md={4} className={`${styles.item} my-4`} key={index}>
                                <figure>
                                    <SourceFlowImage
                                        src={item.image ? item.image : "/site-assets/placeholders/icon-placeholder.png"}
                                        size="120x120"
                                        alt={item.title}
                                    />
                                </figure>
                                <article className="px-5">
                                    <span dangerouslySetInnerHTML={{__html: item.text}} />
                                </article>
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
        </section>
    )
}